import { Component } from '@angular/core';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Resource } from '../../../store/equipment/equipment.model';
import { Store } from '@ngrx/store';
import { EquipmentState } from '../../../store/equipment/equipment.model';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalPdfComponent } from '../modal-pdf/modal-pdf.component';

@Component({
  selector: 'app-resources-panel',
  standalone: true,
  imports: [ExpansionPanelComponent, MatCardModule, MatIconModule, CommonModule],
  templateUrl: './resources-panel.component.html',
  styleUrls: ['./resources-panel.component.css']
})

export class ResourcesPanelComponent {
 
  public resources: Resource[] = [];
  public hasResources: boolean = false;

  constructor(private store: Store<{ equipment: EquipmentState }>, private dialog: MatDialog) {
    this.store.select(state => state.equipment.equipment.resources)
    .subscribe((resources) => {
      this.resources = (resources || []).filter((resource: any) => {
        return (
          resource.url &&
          resource.url.endsWith('.pdf') 
        &&
          !['Manual not available for Model', 'Manual not available for SN'].includes(resource.url)
        );
      });
      this.hasResources = this.resources.length > 0;
    });
  }

  public openModal(resource: Resource): void {
    this.dialog.open(ModalPdfComponent, {
      data: { pdfUrl: resource.downloadUrl, title: resource.title }
    });
  }

}
